module.exports = __webpack_public_path__ + "media/images/task-dc54faa5bc511c86fa3925a2375c06d5.svg";